import React, { useEffect } from 'react';
import { useJwtAuth } from './useJwtLogin';

type Props = {
  apiToken: string;
};

const LoginWithApiToken: React.FC<Props> = ({ apiToken }) => {
  const { doLoginByLegacyApiToken } = useJwtAuth();

  useEffect(() => {
    doLoginByLegacyApiToken(apiToken);
  }, [doLoginByLegacyApiToken, apiToken]);

  return <></>;
};

export default LoginWithApiToken;
